export default __webpack_public_path__ + "static/media/LandRover-Logo-2D-BLU.19104fb4.png";